'use client';

import { type FC } from 'react';

import type { SlotLinkProps } from '../Base/Slot.Link';
import { useLocaleSwitch } from '../../shared/useLocaleSwitch';
import { SlotLink } from '../Base/Slot.Link';

export type LocaleSwitchSlotProps = Pick<SlotLinkProps, 'priority'>;

/** Locale Switch slot with list of helpers in popover */
export const LocaleSwitchSlot: FC<LocaleSwitchSlotProps> = (props) => {
  const { label, href, targetLanguage, switchLocale } = useLocaleSwitch();

  return (
    <SlotLink
      {...props}
      label={label}
      href={href ?? '#'}
      onClick={switchLocale}
      language={targetLanguage}
    >
      <span className="icon-emp-language-switch size-4" />
    </SlotLink>
  );
};
